'use client';

import { FC } from 'react';

import HeroSection from '@/components/common/shops/hero-section';
import ImageTextContainer from '@/components/common/shops/text-image-container';
import type { ShopsPageContent } from '@/configs/shops/shops.config';
import { useAppContext } from '@/providers/app-provider/app-provider';

const defaultHero = {
  backgroundImage: '/imgs/background.jpg',
  title: 'Üzleteink',
  subtitle:
    'Üdvözöljük a Benedek hentesüzletek világában – ahol az erdélyi hagyományos ízek és a minőségi húsáru kéz a kézben járnak.',
};

const defaultShops = [
  {
    image: '/imgs/background.jpg',
    title: 'Lorem ipsum 1',
    description:
      'Description for shop 1. This is a placeholder description that will be replaced with actual data from the admin application.',
  },
  {
    image: '/imgs/background.jpg',
    title: 'Lorem ipsum 2',
    description: 'Description for shop 3. This is a placeholder description that will be replaced',
  },
  {
    image: '/imgs/background.jpg',
    title: 'Lorem ipsum 3',
    description: 'Description for shop 3. This is a placeholder description that will be replaced',
  },
];

const Shops: FC = () => {
  const context = useAppContext<{ shopsPageContent?: ShopsPageContent }>();
  const hero = context?.shopsPageContent?.hero ?? defaultHero;
  const shops = context?.shopsPageContent?.shops ?? defaultShops;

  return (
    <>
      <HeroSection
        backgroundImage={hero.backgroundImage}
        title={hero.title}
        subtitle={hero.subtitle}
      />
      <div className="container mx-auto px-5 py-8">
        {shops.map((shop, index) => (
          <ImageTextContainer
            key={index}
            image={shop.image}
            title={shop.title}
            description={shop.description}
            reverse={index % 2 === 1}
          />
        ))}
      </div>
    </>
  );
};

export default Shops;
